import { Checkbox, ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import { MenuButtonProps } from './index.js';

export default function MenuButtonOptions<T>({
  isMultiselect,
  onClick,
  options,
  selectedValues,
  setOpen,
}: MenuButtonProps<T> & { setOpen: (open: boolean) => void }) {
  return (
    <>
      {options?.map(({ label, value, key, icon, disabled, ...rest }) => {
        const iconItem = icon && (
          <>
            <ListItemIcon className="!min-w-fit mr-2">{icon}</ListItemIcon>
            <ListItemText>{label}</ListItemText>
          </>
        );
        const defaultItem = (
          <>
            {isMultiselect && (
              <ListItemIcon>
                <Checkbox
                  checked={selectedValues.includes(value)}
                  color="primary"
                  style={{ marginTop: 0 }}
                />
              </ListItemIcon>
            )}
            {label}
          </>
        );
        return (
          <MenuItem
            style={isMultiselect && { padding: '0 16px 0 4px' }}
            key={key}
            onClick={(): void => {
              onClick(value);
              if (!isMultiselect) setOpen(false);
            }}
            disabled={disabled}
            {...rest}
          >
            {iconItem ? iconItem : defaultItem}
          </MenuItem>
        );
      })}
    </>
  );
}
